import React, { useEffect, useState } from 'react';

const MiniCart = ({ quantity }) => {
  const [isUpdated, setIsUpdated] = useState(false);
  const [skipAnimation, setSkipAnimation] = useState(true);

  useEffect(() => {
    if (skipAnimation) {
      setSkipAnimation(false);
      return;
    }
    setIsUpdated(true);
    setTimeout(() => {
      setIsUpdated(false);
    }, 1000);
  }, [quantity]);

  if (!(quantity > 0)) {
    return null;
  }
  return (
    <span
      className={`absolute bottom-0 right-0 flex min-h-3 min-w-3 items-center justify-center rounded-full bg-[#43A537] px-1 text-[0.5rem] font-extrabold text-white ${isUpdated && 'animate-mini-cart'}`}
    >
      {quantity}
    </span>
  );
};

export default MiniCart;
